import React from 'react';
import AccountBalanceOutlined from '@mui/icons-material/AccountBalanceOutlined';
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import AnalyticsOutlined from '@mui/icons-material/AnalyticsOutlined';
import AppRegistration from '@mui/icons-material/AppRegistration';
import AssignmentLateOutlined from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import AssuredWorkloadOutlined from '@mui/icons-material/AssuredWorkloadOutlined';
import AttachMoneyOutlined from '@mui/icons-material/AttachMoneyOutlined';
import AutoAwesomeMotionOutlined from '@mui/icons-material/AutoAwesomeMotionOutlined';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';
import AutoGraphOutlined from '@mui/icons-material/AutoGraphOutlined';
import BarChartRounded from '@mui/icons-material/BarChartRounded';
import Block from '@mui/icons-material/Block';
import BookOutlined from '@mui/icons-material/BookOutlined';
import BusAlert from '@mui/icons-material/BusAlert';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import CellWifiOutlined from '@mui/icons-material/CellWifiOutlined';
import CloudSync from '@mui/icons-material/CloudSync';
import CommentOutlined from '@mui/icons-material/CommentOutlined';
import ContactPageOutlined from '@mui/icons-material/ContactPageOutlined';
import ContentPasteOutlined from '@mui/icons-material/ContentPasteOutlined';
import ContentPasteSearchOutlined from '@mui/icons-material/ContentPasteSearchOutlined';
import CorporateFareOutlined from '@mui/icons-material/CorporateFareOutlined';
import CreditCardOutlined from '@mui/icons-material/CreditCardOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import DataArrayOutlined from '@mui/icons-material/DataArrayOutlined';
import DateRangeOutlined from '@mui/icons-material/DateRangeOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import DeviceHub from '@mui/icons-material/DeviceHub';
import DevicesOutlined from '@mui/icons-material/DevicesOutlined';
import DisplaySettingsOutlined from '@mui/icons-material/DisplaySettingsOutlined';
import DocumentScannerOutlined from '@mui/icons-material/DocumentScannerOutlined';
import Edit from '@mui/icons-material/Edit';
import EditNoteOutlined from '@mui/icons-material/EditNoteOutlined';
import EditOutlined from '@mui/icons-material/EditOutlined';
import ElectricBolt from '@mui/icons-material/ElectricBolt';
import EnergySavingsLeafOutlined from '@mui/icons-material/EnergySavingsLeafOutlined';
import EvStationOutlined from '@mui/icons-material/EvStationOutlined';
import FactCheckOutlined from '@mui/icons-material/FactCheckOutlined';
import FactoryOutlined from '@mui/icons-material/FactoryOutlined';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import FormatListNumbered from '@mui/icons-material/FormatListNumbered';
import FoundationOutlined from '@mui/icons-material/FoundationOutlined';
import Gavel from '@mui/icons-material/Gavel';
import GroupAddOutlined from '@mui/icons-material/GroupAddOutlined';
import GroupOutlined from '@mui/icons-material/GroupOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import GridOnOutlined from '@mui/icons-material/GridOnOutlined';
import Handshake from '@mui/icons-material/Handshake';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';
import HeadsetMic from '@mui/icons-material/HeadsetMic';
import HelpOutlineOutlined from '@mui/icons-material/HelpOutlineOutlined';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import HomeWorkOutlined from '@mui/icons-material/HomeWorkOutlined';
import InsertChartOutlined from '@mui/icons-material/InsertChartOutlined';
import InstallDesktop from '@mui/icons-material/InstallDesktop';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import Key from '@mui/icons-material/Key';
import LanOutlined from '@mui/icons-material/LanOutlined';
import LayersOutlined from '@mui/icons-material/LayersOutlined';
import LocalAtmOutlined from '@mui/icons-material/LocalAtmOutlined';
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import MapOutlined from '@mui/icons-material/MapOutlined';
import MergeType from '@mui/icons-material/MergeType';
import ModeOfTravelOutlined from '@mui/icons-material/ModeOfTravelOutlined';
import MoreTimeRounded from '@mui/icons-material/MoreTimeRounded';
import NaturePeopleOutlined from '@mui/icons-material/NaturePeopleOutlined';
import NotificationsNone from '@mui/icons-material/NotificationsNone';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import PaymentOutlined from '@mui/icons-material/PaymentOutlined';
import Payments from '@mui/icons-material/Payments';
import PaymentsOutlined from '@mui/icons-material/PaymentsOutlined';
import PendingActions from '@mui/icons-material/PendingActions';
import PendingActionsOutlined from '@mui/icons-material/PendingActionsOutlined';
import Person from '@mui/icons-material/Person';
import PersonAdd from '@mui/icons-material/PersonAdd';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import PointOfSale from '@mui/icons-material/PointOfSale';
import PrecisionManufacturingOutlined from '@mui/icons-material/PrecisionManufacturingOutlined';
import PriceChangeOutlined from '@mui/icons-material/PriceChangeOutlined';
import QrCode2Outlined from '@mui/icons-material/QrCode2Outlined';
import QueryStatsOutlined from '@mui/icons-material/QueryStatsOutlined';
import RadioOutlined from '@mui/icons-material/RadioOutlined';
import ReceiptLong from '@mui/icons-material/ReceiptLong';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import ReceiptOutlined from '@mui/icons-material/ReceiptOutlined';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import RocketLaunch from '@mui/icons-material/RocketLaunch';
import Rule from '@mui/icons-material/Rule';
import RuleFolderOutlined from '@mui/icons-material/RuleFolderOutlined';
import RvHookupOutlined from '@mui/icons-material/RvHookupOutlined';
import SavingsOutlined from '@mui/icons-material/SavingsOutlined';
import ScaleOutlined from '@mui/icons-material/ScaleOutlined';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import SecurityOutlined from '@mui/icons-material/SecurityOutlined';
import SellOutlined from '@mui/icons-material/SellOutlined';
import Settings from '@mui/icons-material/Settings';
import SettingsApplicationsOutlined from '@mui/icons-material/SettingsApplicationsOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SettingsSuggestOutlined from '@mui/icons-material/SettingsSuggestOutlined';
import ShoppingBasket from '@mui/icons-material/ShoppingBasket';
import SlideshowOutlined from '@mui/icons-material/SlideshowOutlined';
import SmartToyOutlined from '@mui/icons-material/SmartToyOutlined';
import SortByAlpha from '@mui/icons-material/SortByAlpha';
import StorageOutlined from '@mui/icons-material/StorageOutlined';
import StoreOutlined from '@mui/icons-material/StoreOutlined';
import Storefront from '@mui/icons-material/Storefront';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import SummarizeOutlined from '@mui/icons-material/SummarizeOutlined';
import ThumbsUpDownOutlined from '@mui/icons-material/ThumbsUpDownOutlined';
import Timeline from '@mui/icons-material/Timeline';
import TranslateOutlined from '@mui/icons-material/TranslateOutlined';
import TravelExplore from '@mui/icons-material/TravelExplore';
import TrendingUp from '@mui/icons-material/TrendingUp';
import UploadFileOutlined from '@mui/icons-material/UploadFileOutlined';
import Videocam from '@mui/icons-material/Videocam';
import ViewKanbanOutlined from '@mui/icons-material/ViewKanbanOutlined';
import ViewListOutlined from '@mui/icons-material/ViewListOutlined';
import WarehouseOutlined from '@mui/icons-material/WarehouseOutlined';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';
import WavingHandOutlined from '@mui/icons-material/WavingHandOutlined';
import WebAssetOutlined from '@mui/icons-material/WebAssetOutlined';
import Webhook from '@mui/icons-material/Webhook';
import WorkOutline from '@mui/icons-material/WorkOutline';
import CustomIcons from './customIcons';

const warnedIconNames = new Set();

const MaterialIcons = {
  AccountBalanceOutlined,
  AccountTreeOutlined,
  AnalyticsOutlined,
  AppRegistration,
  AssignmentLateOutlined,
  AssignmentOutlined,
  AssuredWorkloadOutlined,
  AttachMoneyOutlined,
  AutoAwesomeMotionOutlined,
  AutoAwesomeOutlined,
  AutoGraphOutlined,
  BarChartRounded,
  Block,
  BookOutlined,
  BusAlert,
  BusinessOutlined,
  CalculateOutlined,
  CalendarMonthOutlined,
  CategoryOutlined,
  CellWifiOutlined,
  CloudSync,
  CommentOutlined,
  ContactPageOutlined,
  ContentPasteOutlined,
  ContentPasteSearchOutlined,
  CorporateFareOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  DataArrayOutlined,
  DateRangeOutlined,
  DescriptionOutlined,
  DeviceHub,
  DevicesOutlined,
  DisplaySettingsOutlined,
  DocumentScannerOutlined,
  Edit,
  EditNoteOutlined,
  EditOutlined,
  ElectricBolt,
  EnergySavingsLeafOutlined,
  EvStationOutlined,
  FactCheckOutlined,
  FactoryOutlined,
  FolderOutlined,
  FormatListNumbered,
  FoundationOutlined,
  Gavel,
  GroupAddOutlined,
  GroupOutlined,
  GroupsOutlined,
  GridOnOutlined,
  Handshake,
  HandshakeOutlined,
  HeadsetMic,
  HelpOutlineOutlined,
  HomeOutlined,
  HomeWorkOutlined,
  InsertChartOutlined,
  InstallDesktop,
  Inventory2Outlined,
  Key,
  LanOutlined,
  LayersOutlined,
  LocalAtmOutlined,
  LocalOfferOutlined,
  LocalShippingOutlined,
  MapOutlined,
  MergeType,
  ModeOfTravelOutlined,
  MoreTimeRounded,
  NaturePeopleOutlined,
  NotificationsNone,
  NotificationsOutlined,
  PaymentOutlined,
  Payments,
  PaymentsOutlined,
  PendingActions,
  PendingActionsOutlined,
  Person,
  PersonAdd,
  PersonOutlineOutlined,
  PictureAsPdf,
  PointOfSale,
  PrecisionManufacturingOutlined,
  PriceChangeOutlined,
  QrCode2Outlined,
  QueryStatsOutlined,
  RadioOutlined,
  ReceiptLong,
  ReceiptLongOutlined,
  ReceiptOutlined,
  ReportProblemOutlined,
  RocketLaunch,
  Rule,
  RuleFolderOutlined,
  RvHookupOutlined,
  SavingsOutlined,
  ScaleOutlined,
  ScienceOutlined,
  SecurityOutlined,
  SellOutlined,
  Settings,
  SettingsApplicationsOutlined,
  SettingsOutlined,
  SettingsSuggestOutlined,
  ShoppingBasket,
  SlideshowOutlined,
  SmartToyOutlined,
  SortByAlpha,
  StorageOutlined,
  StoreOutlined,
  Storefront,
  StorefrontOutlined,
  SummarizeOutlined,
  ThumbsUpDownOutlined,
  Timeline,
  TranslateOutlined,
  TravelExplore,
  TrendingUp,
  UploadFileOutlined,
  Videocam,
  ViewKanbanOutlined,
  ViewListOutlined,
  WarehouseOutlined,
  WarningAmberOutlined,
  WavingHandOutlined,
  WebAssetOutlined,
  Webhook,
  WorkOutline,
};

export const MaterialIcon = ({ icon, iconName, showDefaultIcon = true, ...props }) => {
  if (icon) {
    if (React.isValidElement(icon)) {
      return React.cloneElement(icon, props);
    }

    const IconComponent = icon;

    return <IconComponent {...props} />;
  }

  let Icon = MaterialIcons[iconName];

  if (!Icon) {
    Icon = CustomIcons[iconName];
  } else if (!warnedIconNames.has(iconName)) {
    warnedIconNames.add(iconName);
    console.warn(
      `Icon '${iconName}' is dynamically imported and will be deprecated in the future.
Please use the 'icon' prop instead and pass in the component to render. \`icon={${iconName}}\``
    );
  }

  if (!Icon) {
    console.warn(`Icon not found: ${iconName}`);
    return showDefaultIcon ? <HelpOutlineOutlined {...props} /> : null;
  }

  return <Icon {...props} />;
};
